var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProtectie2Sus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 83,
    viewBox: "0 0 76 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 40L75 40",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75 40.5V4",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.500001 40.5L0.500002 4",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.5L75 4.50001",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8835 11.5455V29H18.7216V11.5455H21.8835ZM43.4396 21.6619L31.7805 27.0483V24.0227L40.0646 20.4688L39.9709 20.6307V20.2386L40.0646 20.4006L31.7805 16.8466V13.821L43.4396 19.2074V21.6619ZM59.5881 21.6619L47.929 27.0483V24.0227L56.2131 20.4688L56.1193 20.6307V20.2386L56.2131 20.4006L47.929 16.8466V13.821L59.5881 19.2074V21.6619Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtectie2Sus);
export default __webpack_public_path__ + "static/media/protectie_2_sus.17e1ecc57566b92e54f471d92518e916.svg";
export { ForwardRef as ReactComponent };